import { useGLTF } from '@react-three/drei';
import * as global from "../../data/global";

export function An8(props) {
    const { nodes } = useGLTF('3ds/an/An8.gltf');
    return (
        <group {...props} dispose={null}>
            <mesh
                ref={e => {
                    if (!e) return;
                    if (!global.gw.geometries.An8) {
                        global.gw.geometries.An8 = e.geometry;
                    }
                }}
                name="An8"
                geometry={nodes.An8.geometry}
                rotation={[Math.PI / 2, 0, 0]}
                {...props.meshProps}
            />
        </group>
    );
}

useGLTF.preload('3ds/an/An8.gltf');